export default "__VITE_ASSET__c914c36a__"